import { variants, ReadonlyTextFieldInputTheme } from '../ReadonlyTextFieldInputStyles.css';
import { multiVariantStyles } from './ReadonlyTextFieldInputVariants.css';

const ReadonlyTextFieldInputRedwoodTheme: ReadonlyTextFieldInputTheme = {
  baseTheme: '',
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { ReadonlyTextFieldInputRedwoodTheme };
